export default __webpack_public_path__ + "static/graphic-score-1280-dcdf46ce15d1623548c3dc021ca66d37.svg";